// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "基础英语（一）",
      "tec": "曹翠",
      "week": "6,8,10,12,14,16周",
      "add": "教学楼A座123信息"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "陈钢",
      "week": "6-17周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "金霞",
      "week": "6-10周",
      "add": "教学楼C座306教务"
    },
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "6-9周",
      "add": "教学楼C座115教务"
    },
    0
  ],
  "2": [
    {
      "sub": "数据结构与算法",
      "tec": "曹福毅",
      "week": "6-17周",
      "add": "教学楼B座224自控"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼B座223自控"
    },
    {
      "sub": "计算机组成原理",
      "tec": "郝雪燕",
      "week": "6-17周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "高级语言程序设计",
      "tec": "崔妍",
      "week": "6-17周",
      "add": "实训楼F座302信息"
    },
    0
  ],
  "3": [
    {
      "sub": "基础英语（一）",
      "tec": "曹翠",
      "week": "6-17周",
      "add": "教学楼A座123信息"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "高级语言程序设计",
      "tec": "崔妍",
      "week": "6-17周",
      "add": "教学楼C座111教务"
    },
    {
      "sub": "计算机组成原理",
      "tec": "郝雪燕",
      "week": "6-17周",
      "add": "教学楼B座319能动"
    },
    {
      "sub": "数据结构与算法",
      "tec": "曹福毅",
      "week": "6-17周",
      "add": "教学楼B座120自控"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学基础（一）",
      "tec": "陈钢",
      "week": "6-17单周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "张慧",
      "week": "6-17周",
      "add": "教学楼B座223自控"
    },
    {
      "sub": "军事理论",
      "tec": "于修理",
      "week": "8-16周",
      "add": "教学楼C座215教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
